import noop from 'lodash/noop';
import { fg } from '@atlassian/jira-feature-gating';
import { FIELD_TYPE_MAP } from '@atlassian/jira-issue-analytics/src/services/update-issue-field/constants.tsx';
import { getUpdateAnalyticsFlowHelper } from '@atlassian/jira-issue-analytics/src/services/update-issue-field/index.tsx';
import { SPRINT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useBacklogSelector } from '../../../../../../state/index.tsx';
import { makeIsCardListActiveSprint } from '../../../../../../state/selectors/sprints/index.tsx';
import { getEndAnalyticsSprintActionTaken } from '../../../../../../common/utils.tsx';

export const useSprintEndAnalytics = ({ cardIds }: { cardIds: number[] }) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const getIsToActiveSprint = useBacklogSelector(makeIsCardListActiveSprint);

	if (!fg('one_event_rules_them_all_fg')) {
		return noop;
	}
	if (cardIds.length !== 1) {
		return noop;
	}

	return (oldValId: string | undefined, newValId: string, isFromActiveSprint = false) => {
		const actionTaken = getEndAnalyticsSprintActionTaken(oldValId, newValId);
		if (!actionTaken) {
			getUpdateAnalyticsFlowHelper().fireAnalyticsEnd(FIELD_TYPE_MAP[SPRINT_TYPE], {
				analytics: createAnalyticsEvent({}),
				attributes: {
					fieldType: SPRINT_TYPE,
					hasRankChanged: true,
				},
			});
			return;
		}
		getUpdateAnalyticsFlowHelper().setAttributes(FIELD_TYPE_MAP[SPRINT_TYPE], {
			actionTaken,
		});
		const isToActiveSprint = getIsToActiveSprint(newValId);

		if (isFromActiveSprint || isToActiveSprint) {
			// end analytics will fire at modal confirm
			return;
		}
		getUpdateAnalyticsFlowHelper().fireAnalyticsEnd(FIELD_TYPE_MAP[SPRINT_TYPE], {
			analytics: createAnalyticsEvent({}),
			attributes: {
				fieldType: SPRINT_TYPE,
			},
		});
	};
};
